import BenchmarkCompareSection from './BenchmarkCompareSection';

export default BenchmarkCompareSection;
